// extracted by mini-css-extract-plugin
module.exports = {"para":"pages-module--para--3gBGH","name":"pages-module--name--9-1Yy","bodyText":"pages-module--body-text--1CYBL"};